import { Button, createMuiTheme, TextField } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getCustomers } from "../../../../api/customer";
import {
  deleteOfferChapter,
  getOfferChaptersById,
  postOfferChapter,
  postOfferChapterNewRevision,
} from "../../../../api/offerChapter";
import {
  getOfferHeaderByIdAndRevision,
  getOfferHeadersById,
  postOfferHeader,
  postOfferHeaderNewRevision,
  updateOfferHeader,
  updateOfferHeaderStatus,
} from "../../../../api/offerHeader";
import {
  deleteOfferPartida,
  getOfferPartidasById,
  postOfferPartida,
  postOfferPartidaNewRevision,
  postOfferPartidaRevision,
} from "../../../../api/offerPartida";
import {
  deleteOfferProduct,
  postOfferProduct,
  postOfferProductNewRevision,
  updateProductOriginal,
} from "../../../../api/offerProduct";
import { getOfferStatus } from "../../../../api/offerStatus";
import { getPartidas, postPartida } from "../../../../api/partida";
import { getPartidaCategories } from "../../../../api/partidaCategory";
import { getProducts } from "../../../../api/product";
import { getProductFamilies } from "../../../../api/productFamily";
import {
  getProductTypeById,
  getProductTypes,
} from "../../../../api/productType";
import { OFFER_STATUS, TIPO_PARTIDA } from "../../../../utils/constants";
import { formatInstallationTime, generatePDF } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EditOfferHeaderDialog from "../../../components/dialogs/EditOfferHeaderDialog";
import EditOfferPartidaDialog from "../../../components/dialogs/EditOfferPartidaDialog";
import EditOfferProductDialog from "../../../components/dialogs/EditOfferProductDialog";
import LoadingDialog from "../../../components/dialogs/LoadingDialog";
import PartidaCategoryTableDialog from "../../../components/dialogs/PartidaCategoryDialog";
import PartidaTableDialog from "../../../components/dialogs/PartidaTableDialog";
import ProductTableDialog from "../../../components/dialogs/ProductTableDialog";
import { offerStatusFormatter } from "../../../components/tables/table";
import { useSkeleton } from "../../../hooks/useSkeleton";
import GuardarPlantillaPartidaDialog from "../../../components/dialogs/GuardarPlantillaPartidaDialog";
import PartidaRevisionTableDialog from "../../../components/dialogs/PartidaRevisionTableDialog";
import { getIVAs } from "../../../../api/iva";
import { getProductMarcas } from "../../../../api/productMarca";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

const IOfferHeader = {
  id: null,
  revision_num: 0,
  num_oferta: null,
  cliente_id: null,
  localizacion: null,
  referencia: null,
  estado_id: OFFER_STATUS.BORRADOR,

  def_margen_material: 0,
  def_margen_m_obra: 0,
  def_margen_subcontrata: 0,

  def_comisiones: 0,
  def_coste_hora_m_obra: 0,
  def_trabajadores_asignados: 0,

  calc_tiempo_jornadas: null,
  calc_tiempo_horas: null,
  calc_m_obra_coste: null,
  calc_m_obra_pvp: null,
  calc_subcontrata_coste: null,
  calc_subcontrata_pvp: null,
  calc_materiales_coste: null,
  calc_materiales_pvp: null,
  calc_total_coste: null,
  calc_total_pvp: null,

  /** @type {[IOfferChapter]} */
  capitulos: [],
};

const IOfferChapter = {
  oferta_id: null,
  revision_num: 0,
  capitulo_id: null,
  ordinal: null,
  partida_categoria_id: null,
  total_precio: null,

  /** @type {[IOfferPartida]} */
  partidas: [],
};

const IOfferPartida = {
  oferta_id: null,
  revision_num: 0,
  capitulo_id: null,
  partida_id: null,
  ordinal: null,
  plantilla_partida_original_id: null,
  referencia: null,
  descripcion: null,
  concepto: null,
  categoria_id: null,
  unidades: null,
  precio_unitario: null,
  precio_total: null,

  tiempo_total: 0,
  mano_obra_coste: 0,
  mano_obra_venta: 0,
  materiales_coste: 0,
  materiales_venta: 0,
  subcontrata_coste: 0,
  subcontrata_venta: 0,
  def_tipo_impotacion_partida: 0,

  /** @type {[IOfferProduct]} */
  productos: [],
};

const IOfferProduct = {
  oferta_id: null,
  revision_num: 0,
  capitulo_id: null,
  partida_id: null,
  producto_id: null,
  ordinal: null,
  descripcion: null,
  referencia: null,
  plantilla_producto_original_id: null,

  tipo_producto_id: null,
  tipo_unidad_id: null,
  def_unidades: null,
  def_factor: null,
  def_precio_compra: null,
  def_descuento_proveedor: null,
  def_tiempo_mano_de_obra: null,

  calc_precio_hora: null,
  calc_mano_de_obra_coste: null,
  calc_mano_de_obra_venta: null,
  calc_materiales_coste: null,

  calc_materiales_venta: null,
  calc_subcontrata_coste: null,
  calc_subcontrata_venta: null,
  calc_total_coste: null,
  calc_total_venta: null,
};

function getEmptyOfferHeader() {
  return { ...IOfferHeader };
}

function getEmptyOfferChapter() {
  return { ...IOfferChapter };
}

function getEmptyOfferPartida() {
  return { ...IOfferPartida };
}

function getEmptyOfferProduct() {
  return { ...IOfferProduct };
}

function offerPartidaTypeFormatter(offerPartidaType) {
  const type = TIPO_PARTIDA.find((x) => x.value === offerPartidaType);
  return (
    <div
      className={`p-2 text-white mr-2`}
      style={{ backgroundColor: type.color, borderRadius: "0.42rem" }}
    >
      {type?.label?.toUpperCase()}
    </div>
  );
}

export default function EditOffersPage() {
  const [offerHeader, setOfferHeader] = useState(getEmptyOfferHeader());
  const [customers, setCustomers] = useState([]);
  const [partidaCategories, setPartidaCategories] = useState([]);
  const [partidas, setPartidas] = useState([]);
  const [ivas, setIvas] = useState([]);
  const [guardarPlantillaPartida, setGuardarPlantillaPartida] = useState({});
  const [
    openGuardarPlantillaPartidaDialog,
    setOpenGuardarPlantillaPartidaDialog,
  ] = useState(false);
  const [guardarPlantillaProducto, setGuardarPlantillaProducto] = useState({});
  const [products, setProducts] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [productFamilies, setProductFamilies] = useState([]);
  const [productMarcas, setProductMarcas] = useState([]);
  const [offerStatus, setOfferStatus] = useState([]);

  const [openEditOfferHeaderDialog, setOpenEditOfferHeaderDialog] = useState(
    false
  );
  const [openPartidaCategoryDialog, setOpenPartidaCategoryDialog] = useState(
    false
  );
  const [
    openPartidaRevisionTableDialog,
    setOpenPartidaRevisionTableDialog,
  ] = useState(false);
  const [openPartidaTableDialog, setOpenPartidaTableDialog] = useState(false);
  const [openProductTableDialog, setOpenProductTableDialog] = useState(false);
  const [top, setTop] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  const offerHeaderId = useParams().id;
  const revisionNumber = useParams().revisionNumber;

  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  const handleBack = () => {
    const prevTablePage = location.state?.page;

    history.push(`/ofertas${prevTablePage ? "?page=" + prevTablePage : ""}`);
  };

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  function handleGetOfferHeader(offerHeaderId, revisionNumber) {
    getOfferHeaderByIdAndRevision(
      offerHeaderId,
      revisionNumber,
      loggedUser?.accessToken
    )
      .then((res) => {
        if (res.status === 200) {
          setOfferHeader({ ...offerHeader, ...res.data });
          setLoading(false);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la oferta.",
        });
        setLoading(false);
        handleBack();
      });
  }

  useEffect(() => {
    getProductMarcas(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductMarcas(res.data);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las marcas de productos.",
        });
      });
    getProducts(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProducts(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los productos.",
        });
        handleBack();
      });
    getOfferStatus(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setOfferStatus(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los estados.",
        });
        handleBack();
      });
    getProductFamilies(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductFamilies(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las familias de productos.",
        });
        handleBack();
      });
    getIVAs(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setIvas(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las familias de productos.",
        });
        handleBack();
      });
    getProductTypes(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setProductTypes(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los tipos de productos.",
        });
        handleBack();
      });
    getCustomers(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setCustomers(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los clientes.",
        });
        handleBack();
      });
    getPartidaCategories(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setPartidaCategories(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las categorías de partidas.",
        });
        handleBack();
      });
    getPartidas(loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setPartidas(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las partidas.",
        });
        handleBack();
      });
    if (!offerHeaderId) {
      disableLoadingData();
      return;
    }
    handleGetOfferHeader(offerHeaderId, revisionNumber);
  }, [offerHeaderId, disableLoadingData, history]);

  useEffect(() => {
    handleResize();

    function handleResize() {
      setWindowHeight(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const isMaterial = (id) => {
    const productType = productTypes.find((x) => x.producto_tipo_id === id);
    return productType.es_material;
  };

  async function handleNuevaRevision() {
    setLoading(true);
    const newNumeroRevision = offerHeader.revision_num + 1;
    try {
      await postOfferHeaderNewRevision(
        offerHeader.id,
        offerHeader,
        loggedUser?.accessToken
      );

      for (const capitulo of offerHeader.capitulos) {
        try {
          await postOfferChapterNewRevision(
            capitulo.capitulo_id,
            capitulo,
            loggedUser?.accessToken
          );

          for (const partida of capitulo.partidas) {
            try {
              await postOfferPartidaNewRevision(
                partida.partida_id,
                partida,
                loggedUser?.accessToken
              );

              for (const producto of partida.productos) {
                try {
                  await postOfferProductNewRevision(
                    producto.producto_id,
                    producto,
                    loggedUser?.accessToken
                  );
                } catch (error) {
                  alertError({
                    error,
                    customMessage: "No se ha podido guardar el producto",
                  });
                  setLoading(false);
                  return;
                }
              }
            } catch (error) {
              alertError({
                error,
                customMessage: "No se ha podido guardar la partida",
              });
              setLoading(false);
              return;
            }
          }
        } catch (error) {
          alertError({
            error,
            customMessage: "No se ha podido crear el capítulo",
          });
          setLoading(false);
          return;
        }
      }
    } catch (error) {
      alertError({
        error,
        customMessage: "No se ha podido crear la oferta.",
      });
      setLoading(false);
      return;
    } finally {
      setLoading(false);
      history.push({
        pathname: `/ofertas`,
      });
    }
  }

  function calc_total_costes(
    mano_obra_coste,
    subcontrata_coste,
    materiales_coste
  ) {
    return mano_obra_coste + subcontrata_coste + materiales_coste;
  }

  useEffect(() => {
    // Skip if sticky is disabled or on initial render when we don't know about window height.
    if (windowHeight === 0) return;

    const headerElement = document.querySelector(".header");
    const subheaderElement = document.querySelector(".subheader");
    const headerMobileElement = document.querySelector(".header-mobile");
    let nextMarginTop = 0;

    // mobile header
    if (window.getComputedStyle(headerElement).height === "0px")
      nextMarginTop = headerMobileElement.offsetHeight;
    // desktop header
    else if (document.body.classList.contains("header-minimize-topbar"))
      // hardcoded minimized header height
      nextMarginTop = 60;
    else {
      // normal fixed header
      if (document.body.classList.contains("header-fixed"))
        nextMarginTop += headerElement.offsetHeight;

      if (document.body.classList.contains("subheader-fixed"))
        nextMarginTop += subheaderElement.offsetHeight;
    }
    setTop(nextMarginTop);
    // setTimeout(() => {
    //   const stickyModule = document.querySelector(".stickyModule").offsetHeight;
    //   if (stickyModule) {
    //     nextMarginTop += stickyModule;
    //   }

    //   setTop(nextMarginTop);
    // }, 1000);
  }, [windowHeight]);

  const styles = {
    position: "sticky",
    top: `${top}px`,
    zIndex: 100,
    backgroundColor: "white",
    paddingLeft: "30px",
    paddingRight: "30px",
  };

  function saveOffer() {
    setLoading(true);
    if (!offerHeader?.id) {
      postOfferHeader(offerHeader, loggedUser?.accessToken)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "¡Guardada!",
              customMessage: "Oferta guardada con éxito.",
            });
            handleGetOfferHeader(res.data?.id, res.data?.revision_num);
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guardar la oferta.",
          });
        });
    } else {
      updateOfferHeader(offerHeader?.id, offerHeader, loggedUser?.accessToken)
        .then((res) => {
          if (res.status === 204) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Cambios guardados con éxito.",
            });
            handleGetOfferHeader(offerHeader?.id, offerHeader?.revision_num);
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setOfferHeader({ ...offerHeader, [element]: event.target.value });
  };

  const [expandedChapters, setExpandedChapters] = useState([]);
  const [expandedPartidas, setExpandedPartidas] = useState([]);
  const [expandedProducts, setExpandedProducts] = useState([]);
  const [dataPartidaRevisionTable, setDataPartidaRevisionTable] = useState([]);
  const [dataCabecerasRevisionTable, setDataCabecerasRevisionTable] = useState(
    []
  );
  const [dataCapitulosRevisionTable, setDataCapitulosRevisionTable] = useState(
    []
  );

  const [selectedChapter, setSelectedChapter] = useState(null);
  const [selectedPartida, setSelectedPartida] = useState(null);

  const [isVisible, setIsVisible] = useState(true);
  const divRef = useRef(null);

  const checkVisibility = () => {
    if (divRef.current) {
      const rect = divRef.current.getBoundingClientRect();
      // Comprueba si el div está dentro del viewport
      const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= window.innerHeight &&
        rect.right <= window.innerWidth;

      setIsVisible(isInViewport);
    }
  };

  useEffect(() => {
    // Agregar el evento de scroll
    window.addEventListener("scroll", checkVisibility);
    // Comprobar la visibilidad inicial
    checkVisibility();

    return () => {
      // Limpiar el evento de scroll
      window.removeEventListener("scroll", checkVisibility);
    };
  }, []);

  const OfferChapter = ({ chapter }) => {
    /**
     * @type {IOfferChapter}
     */
    const offerChapter = { ...IOfferChapter, ...chapter };

    const expanded = expandedChapters?.some(
      (chapterId) => chapterId === offerChapter?.capitulo_id
    );

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    return (
      <>
        <div className="bg-primary text-white p-3 my-1">
          <div className="d-flex justify-content-between align-items-center">
            <div
              className={`d-flex align-items-${expanded ? "start" : "center"}`}
            >
              {expanded ? (
                <ExpandLess
                  style={{ cursor: "pointer" }}
                  htmlColor="white"
                  onClick={() => {
                    setExpandedChapters(
                      expandedChapters?.filter(
                        (chapterId) => chapterId !== offerChapter?.capitulo_id
                      )
                    );
                  }}
                />
              ) : (
                <ExpandMore
                  style={{ cursor: "pointer" }}
                  htmlColor="white"
                  onClick={() => {
                    setExpandedChapters(
                      expandedChapters?.concat(offerChapter?.capitulo_id)
                    );
                  }}
                />
              )}
              <div className="ml-2">
                <strong>
                  {`CAPÍTULO ${offerChapter?.ordinal}: ${offerChapter?.partida_categoria?.descripcion}`.toUpperCase()}
                </strong>
                {expanded && (
                  <div>PARTIDAS: {offerChapter?.partidas?.length}</div>
                )}
              </div>
            </div>
            <div className="text-right">
              <div className="mb-1">
                <strong>TOTAL: {offerChapter?.total_precio} €</strong>
              </div>
              <Button
                onClick={async () => {
                  try {
                    const resHeader = await getOfferHeadersById(
                      offerChapter.oferta_id,
                      loggedUser?.accessToken
                    );
                    if (resHeader.status === 200) {
                      setDataCabecerasRevisionTable(resHeader.data);
                    }
                  } catch (error) {
                    alertError({
                      error: error,
                      customMessage: "No se han podido obtener las ofertas.",
                    });
                  }
                  try {
                    const resChapter = await getOfferChaptersById(
                      offerChapter.capitulo_id,
                      loggedUser?.accessToken
                    );
                    if (resChapter.status === 200) {
                      setDataCapitulosRevisionTable(resChapter.data);
                    }
                  } catch (error) {
                    alertError({
                      error: error,
                      customMessage: "No se han podido obtener los capitulos.",
                    });
                  }
                  try {
                    const resPartidas = await getOfferPartidasById(
                      offerChapter.oferta_id,
                      loggedUser?.accessToken
                    );
                    if (resPartidas.status === 200) {
                      setDataPartidaRevisionTable(resPartidas.data);
                    }
                  } catch (error) {
                    alertError({
                      error: error,
                      customMessage: "No se han podido obtener las partidas.",
                    });
                  }
                  setSelectedChapter(offerChapter);
                  setOpenPartidaRevisionTableDialog(true);
                }}
                style={{
                  fontSize: "10px",
                  marginRight: "0.75rem",
                }}
                className="p-2"
                variant="contained"
                color="white"
              >
                Recuperar partida
              </Button>
              <Button
                onClick={() => {
                  setSelectedChapter(offerChapter);
                  setOpenPartidaTableDialog(true);
                }}
                style={{ fontSize: "10px" }}
                className="p-2"
                variant="contained"
                color="white"
              >
                Nueva partida
              </Button>
              <Button
                style={{ fontSize: "10px" }}
                onClick={() => setOpenConfirmDialog(true)}
                className="ml-3 p-2 bg-danger text-white"
                variant="outlined"
                color="white"
              >
                Eliminar capítulo
              </Button>
            </div>
          </div>
        </div>
        {expanded && (
          <>
            {offerChapter?.partidas?.map((partida, index) => {
              return (
                <div
                  key={"partida-" + index}
                  className="my-2 p-3"
                  style={{ border: "1px solid black" }}
                >
                  <OfferPartida
                    partida={partida}
                    chapterOrder={offerChapter.ordinal}
                  />
                </div>
              );
            })}
          </>
        )}
        <PartidaTableDialog
          open={openPartidaTableDialog}
          setOpen={setOpenPartidaTableDialog}
          data={partidas}
          onSelect={(selectedPartidaId) => {
            let saveOfferPartida = {
              oferta_id: offerHeader?.id,
              revision_num: offerHeader?.revision_num,
              capitulo_id: selectedChapter?.capitulo_id,
              plantilla_partida_original_id: selectedPartidaId,
              def_mano_de_obra_subcontrata_coste:
                offerHeader.def_coste_hora_subcontrata,
            };

            setLoading(true);

            postOfferPartida(saveOfferPartida, loggedUser?.accessToken)
              .then((res) => {
                if (res.status === 201) {
                  alertSuccess({
                    title: "¡Guardada!",
                    customMessage: "Partida guardada con éxito",
                  });
                  setExpandedPartidas(
                    expandedPartidas?.concat(res.data?.partida_id)
                  );
                  setExpandedChapters(
                    expandedChapters?.concat(res.data?.capitulo_id)
                  );
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido guardar la partida",
                });
                setLoading(false);
              });
          }}
        />
        <PartidaRevisionTableDialog
          open={openPartidaRevisionTableDialog}
          setOpen={setOpenPartidaRevisionTableDialog}
          cabeceras={dataCabecerasRevisionTable}
          partidas={dataPartidaRevisionTable}
          capitulos={dataCapitulosRevisionTable}
          partidasCategorias={partidaCategories}
          onSelect={(selectedPartida) => {
            let listaPartidas = [
              selectedPartida,
              {
                oferta_id: offerHeader?.id,
                revision_num: offerHeader?.revision_num,
                capitulo_id: selectedChapter?.capitulo_id,
              },
            ];

            setLoading(true);

            postOfferPartidaRevision(
              selectedPartida.partida_id,
              listaPartidas,
              loggedUser?.accessToken
            )
              .then((res) => {
                if (res.status === 201) {
                  alertSuccess({
                    title: "¡Guardada!",
                    customMessage: "Partida guardada con éxito",
                  });
                  setExpandedPartidas(
                    expandedPartidas?.concat(res.data?.partida_id)
                  );
                  setExpandedChapters(
                    expandedChapters?.concat(res.data?.capitulo_id)
                  );
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido guardar la partida",
                });
                setLoading(false);
              });
          }}
        />
        <ConfirmDialog
          title={`¿Estás seguro de que quieres eliminar este capítulo?`}
          children={
            "Se eliminaran también todos sus partidas y productos asociados"
          }
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            setLoading(true);
            deleteOfferChapter(
              offerChapter?.capitulo_id,
              loggedUser?.accessToken
            )
              .then((res) => {
                if (res.status === 204) {
                  alertSuccess({
                    title: "¡Eliminad!",
                    customMessage: "Capítulo eliminado con éxito",
                  });
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido eliminar el capítulo",
                });
                setLoading(false);
              });
          }}
        />
      </>
    );
  };

  const OfferPartida = ({ partida, chapterOrder }) => {
    /**
     * @type {IOfferPartida}
     */
    const offerPartida = { ...IOfferPartida, ...partida };

    const expanded = expandedPartidas?.some(
      (partidaId) => partidaId === offerPartida?.partida_id
    );

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openEditPartidaDialog, setOpenEditPartidaDialog] = useState(false);

    return (
      <>
        <div className="d-flex flex-column">
          <div className="d-flex align-items-center col-12 px-0">
            {expanded ? (
              <ExpandLess
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setExpandedPartidas(
                    expandedPartidas?.filter(
                      (partidaId) => partidaId !== offerPartida?.partida_id
                    )
                  );
                }}
              />
            ) : (
              <>
                <div className="d-flex justify-content-center col-12 px-0">
                  <ExpandMore
                    className="mr-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setExpandedPartidas(
                        expandedPartidas?.concat(offerPartida?.partida_id)
                      );
                    }}
                  />
                  <table
                    className="table table-bordered w-100"
                    style={{ tableLayout: "auto" }}
                  >
                    <thead>
                      <tr>
                        <th className="p-2">Pos.</th>
                        <th className="p-2">Ud.</th>
                        <th className="p-2">Descripción</th>
                        <th className="p-2">Med.</th>
                        <th className="p-2">Precio</th>
                        <th className="p-2">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="p-2">{`${chapterOrder}.${offerPartida.ordinal}`}</td>
                        <td className="p-2">{offerPartida?.tipo_unidad}</td>
                        <td className="p-2">{offerPartida?.descripcion}</td>
                        <td className="p-2">{offerPartida?.unidades}</td>
                        <td className="p-2 text-right">
                          {offerPartida?.precio_unitario.toLocaleString(
                            "es-ES",
                            { style: "currency", currency: "EUR" }
                          )}
                        </td>
                        <td className="p-2 text-right">
                          {offerPartida?.precio_total.toLocaleString("es-ES", {
                            style: "currency",
                            currency: "EUR",
                          })}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
          <div className="d-flex justify-content-end col-12 px-0">
            {offerPartidaTypeFormatter(
              offerPartida.def_tipo_impotacion_partida
            )}
            <Button
              onClick={() => {
                setOpenGuardarPlantillaPartidaDialog(true);
              }}
              style={{ fontSize: "10px" }}
              className="p-2"
              variant="contained"
              color="white"
            >
              Guardar como nueva partida
            </Button>
            <Button
              style={{ fontSize: "10px" }}
              onClick={() => {
                setOpenEditPartidaDialog(true);
              }}
              className="ml-3 p-2"
              variant="outlined"
              color="white"
            >
              Editar partida
            </Button>
            <Button
              style={{ fontSize: "10px" }}
              onClick={() => {
                setOpenConfirmDialog(true);
              }}
              className="ml-3 p-2 bg-danger text-white"
              variant="outlined"
              color="white"
            >
              Eliminar partida
            </Button>
          </div>
        </div>
        {expanded && (
          <>
            <div className="row d-flex align-items-center">
              <div className="col-md-6">
                <TextField
                  label="Descripción"
                  value={offerPartida?.descripcion}
                  onChange={() => {}}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-6">
                <TextField
                  label="Referencia"
                  value={offerPartida?.referencia}
                  onChange={() => {}}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>
            <div className="mb-1 ml-3" style={{ fontSize: "11px" }}>
              Concepto
            </div>
            <div
              style={{
                color: "#212121",
                fontSize: "15px",
                padding: "10px",
                border: "1px solid #c4c4c4",
                borderRadius: "0.42rem",
              }}
              dangerouslySetInnerHTML={{
                __html: offerPartida?.concepto,
              }}
            />
            <div className="row d-flex justify-content-end">
              <div className="col-md-2">
                <strong>Tiempos</strong>
                <TextField
                  label="Tiempo"
                  disabled={offerPartida.def_tipo_impotacion_partida > 1}
                  value={
                    formatInstallationTime(
                      offerPartida?.tiempo_total / offerPartida.unidades
                    ) + " h"
                  }
                  onChange={() => {}}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="Tiempo"
                  disabled={offerPartida.def_tipo_impotacion_partida > 1}
                  value={
                    formatInstallationTime(offerPartida?.tiempo_total) + " h"
                  }
                  onChange={() => {}}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <strong>Mano de obra Interna</strong>
                <TextField
                  label="Coste"
                  disabled={offerPartida.def_tipo_impotacion_partida > 0}
                  value={offerPartida.mano_de_obra_coste + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="PVP"
                  disabled={offerPartida.def_tipo_impotacion_partida > 0}
                  value={offerPartida.mano_de_obra_venta + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <strong>Mano de obra Subcontrata</strong>
                <TextField
                  label="Coste"
                  disabled={offerPartida.def_tipo_impotacion_partida !== 1}
                  value={
                    offerPartida.def_tipo_impotacion_partida !== 2
                      ? offerPartida.subcontrata_coste + " €"
                      : "0 €"
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="PVP"
                  disabled={offerPartida.def_tipo_impotacion_partida !== 1}
                  value={
                    offerPartida.def_tipo_impotacion_partida !== 2
                      ? offerPartida.subcontrata_venta + " €"
                      : "0 €"
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                {offerPartida?.def_tipo_impotacion_partida === 1 && (
                  <TextField
                    label="Coste Mano de obra"
                    value={
                      offerPartida.def_mano_de_obra_subcontrata_coste + " €"
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                )}
              </div>
              <div className="col-md-2">
                <strong>Materiales</strong>
                <TextField
                  label="Coste"
                  disabled={offerPartida.def_tipo_impotacion_partida > 1}
                  value={offerPartida.materiales_coste + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="PVP"
                  disabled={offerPartida.def_tipo_impotacion_partida > 1}
                  value={offerPartida.materiales_venta + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-4">
                <strong>Total</strong>
                <TextField
                  label="Coste"
                  value={
                    calc_total_costes(
                      offerPartida.mano_de_obra_coste,
                      offerPartida.subcontrata_coste,
                      offerPartida.materiales_coste
                    ) + " €"
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="PVP"
                  value={offerPartida.precio_total + " €"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="PVP"
                  value={
                    offerPartida.precio_total -
                    calc_total_costes(
                      offerPartida.mano_de_obra_coste,
                      offerPartida.subcontrata_coste,
                      offerPartida.materiales_coste
                    ) +
                    " €"
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>
            <hr />
            <div className="row d-flex justify-content-end">
              <div className="col-md-2">
                <TextField
                  label="Tipo de unidades"
                  value={offerPartida?.tipo_unidad}
                  onChange={() => {}}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <TextField
                  label="Unidades"
                  value={offerPartida?.unidades}
                  onChange={() => {}}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <TextField
                  label="pvp unitario"
                  value={offerPartida?.precio_unitario + " €"}
                  onChange={() => {}}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <TextField
                  label="pvp total"
                  value={offerPartida?.precio_total + " €"}
                  onChange={() => {}}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>
            {offerPartida?.def_tipo_impotacion_partida <= 1 && (
              <>
                <div className="bg-primary text-white p-3 my-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <strong>DESCOMPUESTO</strong>
                    <Button
                      className="p-2"
                      style={{ fontSize: "10px" }}
                      onClick={() => {
                        setSelectedPartida(offerPartida);
                        setOpenProductTableDialog(true);
                      }}
                      variant="contained"
                      color="white"
                    >
                      Añadir producto
                    </Button>
                  </div>
                </div>
                {offerPartida?.productos?.map((product, index) => {
                  return (
                    <div key={"product-" + index}>
                      <OfferProduct product={product} />
                    </div>
                  );
                })}
              </>
            )}
          </>
        )}
        <ConfirmDialog
          title={`¿Estás seguro de que quieres eliminar esta partida?`}
          children={"Se eliminaran también todos sus productos asociados"}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            setLoading(true);
            deleteOfferPartida(offerPartida.partida_id, loggedUser?.accessToken)
              .then((res) => {
                if (res.status === 204) {
                  alertSuccess({
                    title: "¡Eliminada!",
                    customMessage: "Partida eliminada con éxito",
                  });
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido eliminar la partida",
                });
                setLoading(false);
              });
          }}
        />
        <ProductTableDialog
          title="Productos"
          open={openProductTableDialog}
          setOpen={setOpenProductTableDialog}
          data={products?.filter(
            (x) =>
              !selectedPartida?.productos?.some(
                (y) => y?.plantilla_producto_original_id === x?.id
              )
          )}
          productMarcas={productMarcas}
          productFamilies={productFamilies}
          productTypes={productTypes}
          onSelect={(selectedProductId) => {
            let saveOfferProduct = {
              oferta_id: offerHeader?.id,
              revision_num: offerHeader?.revision_num,
              capitulo_id: selectedPartida?.capitulo_id,
              partida_id: selectedPartida?.partida_id,
              plantilla_producto_original_id: selectedProductId,
            };
            setLoading(true);

            postOfferProduct(saveOfferProduct, loggedUser?.accessToken)
              .then((res) => {
                if (res.status === 201) {
                  alertSuccess({
                    title: "¡Guardado!",
                    customMessage: "Producto guardado con éxito",
                  });
                  setExpandedProducts(
                    expandedProducts?.concat(res.data?.producto_id)
                  );
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido guardar el producto",
                });
                setLoading(false);
              });
          }}
        />
        <EditOfferPartidaDialog
          title="Editar partida"
          open={openEditPartidaDialog}
          setOpen={setOpenEditPartidaDialog}
          productTypes={productTypes}
          data={partida}
          onSave={() =>
            handleGetOfferHeader(
              offerPartida?.oferta_id,
              offerPartida?.revision_num
            )
          }
        />
        <GuardarPlantillaPartidaDialog
          title="Guardar Plantilla Partida"
          open={openGuardarPlantillaPartidaDialog}
          setOpen={setOpenGuardarPlantillaPartidaDialog}
          data={partida}
        />
      </>
    );
  };

  const OfferProduct = ({ product }) => {
    /**
     * @type {IOfferProduct}
     */
    const offerProduct = { ...IOfferProduct, ...product };

    const expanded = expandedProducts?.some(
      (productId) => productId === offerProduct?.producto_id
    );

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [openEditProductDialog, setOpenEditProductDialog] = useState(false);
    const [tipoMaterial, setTipoMaterial] = useState("");

    useEffect(() => {
      getProductTypeById(offerProduct.tipo_producto_id, loggedUser?.accessToken)
        .then((res) => {
          if (res.status === 200) {
            setTipoMaterial(res.data);
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido obtener el tipo de material.",
          });
        });
    }, [product]);

    return (
      <>
        <div className="d-flex align-items-center mt-2">
          {expanded ? (
            <ExpandLess
              style={{ cursor: "pointer" }}
              onClick={() => {
                setExpandedProducts(
                  expandedProducts?.filter(
                    (productId) => productId !== offerProduct?.producto_id
                  )
                );
              }}
            />
          ) : (
            <>
              <ExpandMore
                className="mr-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setExpandedProducts(
                    expandedProducts?.concat(offerProduct?.producto_id)
                  );
                }}
              />
              <div>{offerProduct?.descripcion}</div>
            </>
          )}
          <hr className="ml-2" style={{ flex: 1 }} />
        </div>
        {expanded && (
          <>
            <div className="row">
              <div className="col-12 d-flex justify-content-end mb-3">
                <Button
                  onClick={() => {
                    setLoading(true);
                    updateProductOriginal(
                      offerProduct?.producto_id,
                      offerProduct,
                      loggedUser?.accessToken
                    )
                      .then((res) => {
                        if (res.status === 204) {
                          alertSuccess({
                            title: "¡Actualizado!",
                            customMessage: "Producto actualizado con éxito",
                          });
                          setLoading(false);
                        }
                      })
                      .catch((error) => {
                        alertError({
                          error: error,
                          customMessage:
                            "No se ha podido actualizar el producto",
                        });
                        setLoading(false);
                      });
                  }}
                  style={{ fontSize: "10px" }}
                  className="p-2"
                  variant="contained"
                  color="white"
                >
                  Actualizar producto original
                </Button>
                <Button
                  style={{ fontSize: "10px" }}
                  onClick={() => setOpenEditProductDialog(true)}
                  className="ml-3 p-2"
                  variant="outlined"
                  color="white"
                >
                  Editar producto
                </Button>
                <Button
                  style={{ fontSize: "10px" }}
                  onClick={() => setOpenConfirmDialog(true)}
                  className="ml-3 p-2 bg-danger text-white"
                  variant="outlined"
                  color="white"
                >
                  Eliminar producto
                </Button>
              </div>
              <div className="col-12 row mb-4">
                <div className="col-md-4">
                  <TextField
                    label="Producto"
                    value={offerProduct?.descripcion}
                    onChange={() => {}}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                <div className="col-md-2">
                  <TextField
                    label="Referencia"
                    value={offerProduct?.referencia}
                    onChange={() => {}}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                <div className="col-md-2">
                  <TextField
                    label="Unidades"
                    value={offerProduct?.def_unidades}
                    onChange={() => {}}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                <div className="col-md-2">
                  <TextField
                    label="Factor"
                    value={offerProduct?.def_factor + " %"}
                    onChange={() => {}}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                <div className="col-md-2">
                  <TextField
                    label="Total"
                    value={offerProduct?.calc_total_coste + " €"}
                    onChange={() => {}}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
                {/* <div className="col-md-1">
                  <TextField
                    label="Descuento proveedor"
                    value={offerProduct?.def_descuento_proveedor + "%"}
                    onChange={() => {}}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: true,
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div> */}
              </div>
              <div className="col-12 p-3">
                <div className="row justify-content-between">
                  <div className="col-md-2">
                    <strong>Tiempos</strong>
                    <TextField
                      label="Unitario"
                      value={
                        formatInstallationTime(
                          offerProduct?.def_tiempo_mano_de_obra
                        ) + " h"
                      }
                      onChange={() => {}}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="Total"
                      value={
                        formatInstallationTime(
                          offerProduct?.def_tiempo_mano_de_obra *
                            offerProduct?.def_unidades
                        ) + " h"
                      }
                      onChange={() => {}}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <strong>Mano de obra</strong>
                    <TextField
                      label="Coste"
                      value={offerProduct.calc_mano_de_obra_coste + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="PVP"
                      value={offerProduct.calc_mano_de_obra_venta + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <strong>Materiales</strong>
                    <TextField
                      label="Coste"
                      value={offerProduct.calc_materiales_coste + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="PVP"
                      value={offerProduct.calc_materiales_venta + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-4">
                    <strong>Total</strong>
                    <TextField
                      label="Coste"
                      value={offerProduct?.calc_total_coste + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="PVP"
                      value={offerProduct.calc_total_venta + " €"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      label="PVP"
                      value={
                        offerProduct.calc_total_venta -
                        offerProduct.calc_total_coste +
                        " €"
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <ConfirmDialog
          title={`¿Estás seguro de que quieres eliminar este producto de la partida de la oferta?`}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            setLoading(true);
            deleteOfferProduct(
              offerProduct?.producto_id,
              loggedUser?.accessToken
            )
              .then((res) => {
                if (res.status === 204) {
                  alertSuccess({
                    title: "¡Eliminado!",
                    customMessage: "Producto eliminado con éxito de la partida",
                  });
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage:
                    "No se ha podido eliminar el producto de la partida",
                });
                setLoading(false);
              });
          }}
        />
        <EditOfferProductDialog
          title="Editar producto"
          open={openEditProductDialog}
          setOpen={setOpenEditProductDialog}
          data={product}
          onSave={() =>
            handleGetOfferHeader(
              offerProduct?.oferta_id,
              offerProduct?.revision_num
            )
          }
        />
      </>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader sticky={false} className="stickyModule" title="Oferta">
            {/* <CardHeaderToolbar>
              <Button
                onClick={() => saveOffer()}
                variant="outlined"
                color="primary"
              >
                Guardar
              </Button>
            </CardHeaderToolbar> */}
          </CardHeader>
          {!isVisible && (
            <>
              <div style={styles}>
                <div
                  className="row d-flex align-items-center"
                  style={{ marginBottom: "6px" }}
                >
                  <div className="col-md-3">
                    <strong style={{ fontSize: "16px" }}>Margen</strong>
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Material"
                      value={offerHeader.def_margen_material + "%"}
                      onChange={handleChange("def_margen_material")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Mano de obra"
                      value={offerHeader.def_margen_m_obra + "%"}
                      onChange={handleChange("def_margen_m_obra")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Subcontrata"
                      value={offerHeader.def_margen_subcontrata + "%"}
                      onChange={handleChange("def_margen_subcontrata")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                </div>
                <div
                  className="row d-flex align-items-center"
                  style={{ marginBottom: "2px" }}
                >
                  <div className="col-md-3">
                    <strong style={{ fontSize: "16px" }}>
                      Recursos internos
                    </strong>
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Trabajadores"
                      value={offerHeader.def_trabajadores_asignados}
                      onChange={handleChange("def_trabajadores_asignados")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      type="number"
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Coste/hora"
                      value={offerHeader.def_coste_hora_m_obra + " €"}
                      onChange={handleChange("def_coste_hora_m_obra")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-md-3">
                    <TextField
                      label="Comisiones"
                      value={offerHeader.def_comisiones + "%"}
                      onChange={handleChange("def_comisiones")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      margin="none"
                      variant="outlined"
                    />
                  </div>
                </div>
                <div className="row d-flex justify-content-start ">
                  <div className="col-md-2">
                    <strong>Tiempos</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Jornadas"
                        value={offerHeader.calc_tiempo_jornadas}
                        onChange={handleChange("calc_tiempo_jornadas")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="Horas"
                        value={offerHeader.calc_tiempo_horas}
                        onChange={handleChange("calc_tiempo_horas")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <strong>Mano de obra</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Coste"
                        value={offerHeader.calc_m_obra_coste + " €"}
                        onChange={handleChange("calc_m_obra_coste")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP"
                        value={offerHeader.calc_m_obra_pvp + " €"}
                        onChange={handleChange("def_trabajadores_asignados")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <strong>Subcontrata</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Coste"
                        value={offerHeader.calc_subcontrata_coste + " €"}
                        onChange={handleChange("calc_subcontrata_coste")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP"
                        value={offerHeader.calc_subcontrata_pvp + " €"}
                        onChange={handleChange("calc_subcontrata_pvp")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <strong>Materiales</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Coste"
                        value={offerHeader.calc_materiales_coste + " €"}
                        onChange={handleChange("calc_materiales_coste")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP"
                        value={offerHeader.calc_materiales_pvp + " €"}
                        onChange={handleChange("calc_materiales_pvp")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <strong>Total</strong>
                    <div className="d-flex flex-row">
                      <TextField
                        label="Coste"
                        value={offerHeader.calc_total_coste + " €"}
                        onChange={handleChange("calc_total_coste")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                      <TextField
                        label="PVP"
                        value={offerHeader.calc_total_pvp + " €"}
                        onChange={handleChange("calc_total_pvp")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          readOnly: true,
                        }}
                        margin="none"
                        variant="outlined"
                        style={{ margin: "5px", minWidth: "auto" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <CardHeader title="Cabecera" sticky={false}>
            <CardHeaderToolbar>
              <div className="d-flex align-items-center w-100">
                <div
                  style={{
                    marginRight: "0.75rem",
                    marginTop: "0.5rem",
                  }}
                >
                  <Button
                    onClick={() => {
                      handleNuevaRevision();
                    }}
                    variant="contained"
                  >
                    Nueva revisión
                  </Button>
                </div>
                <Autocomplete
                  disabled={!offerHeader?.id}
                  style={{ width: "150px" }}
                  id="autocomplete-status"
                  disableClearable
                  options={offerStatus}
                  getOptionLabel={(option) => option.descripcion}
                  value={
                    offerStatus?.find((x) => x.id === offerHeader?.estado_id) ||
                    ""
                  }
                  onChange={(event, selected) => {
                    setLoading(true);
                    updateOfferHeaderStatus(
                      offerHeader?.id,
                      offerHeader?.revision_num,
                      selected?.id,
                      loggedUser?.accessToken
                    )
                      .then((res) => {
                        if (res.status === 204) {
                          alertSuccess({
                            title: "¡Guardado!",
                            customMessage: "Estado actualizado con éxito",
                          });
                          handleGetOfferHeader(
                            offerHeader?.id,
                            offerHeader?.revision_num
                          );
                        }
                      })
                      .catch((error) => {
                        alertError({
                          error: error,
                          customMessage: "No se ha podido cambiar el estado",
                        });
                        setLoading(false);
                      });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Estado"
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
                <Button
                  className="ml-3 btn btn-primary mt-2"
                  onClick={() => {
                    setOpenEditOfferHeaderDialog(true);
                  }}
                  variant="outlined"
                  color="primary"
                >
                  Editar
                </Button>
              </div>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <TextField
                  label="Número de oferta"
                  value={offerHeader.num_oferta}
                  onChange={handleChange("num_oferta")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <Autocomplete
                  id="autocomplete-cliente"
                  disablePortal
                  disableClearable
                  options={customers}
                  getOptionLabel={(option) => option.nombre}
                  value={
                    customers?.find((x) => x.id === offerHeader?.cliente_id) ||
                    ""
                  }
                  onChange={(event, selected) => {
                    setOfferHeader({
                      ...offerHeader,
                      cliente_id: selected?.id || null,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Cliente"
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                      }}
                      required
                    />
                  )}
                />
              </div>
              <div className="col-md-4">
                <TextField
                  label="Localización"
                  value={offerHeader.localizacion}
                  onChange={handleChange("localizacion")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
            </div>
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <TextField
                  id={`reference`}
                  label="Referencia de obra"
                  value={offerHeader.referencia}
                  onChange={handleChange("referencia")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <TextField
                  id={`revision`}
                  label="Revisión"
                  value={offerHeader.revision_num}
                  onChange={handleChange("revision_num")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  required
                />
              </div>
              <div className="col-md-4">
                <div className="d-flex justify-content-end">
                  {offerStatusFormatter(
                    offerStatus?.find((x) => x.id === offerHeader?.estado_id)
                  )}
                  <Button
                    className="ml-3"
                    onClick={() => {
                      const objOferta = { ...offerHeader };
                      objOferta.cliente_nombre =
                        customers?.find((x) => x.id === offerHeader?.cliente_id)
                          .nombre || "";
                      generatePDF(objOferta);
                    }}
                    variant="outlined"
                    color="primary"
                  >
                    Descargar
                  </Button>
                </div>
              </div>
            </div>
            <hr />
            <div className="row d-flex align-items-center">
              <div className="col-md-3">
                <strong>Margen</strong>
              </div>
              <div className="col-md-3">
                <TextField
                  label="Material"
                  value={offerHeader.def_margen_material + "%"}
                  onChange={handleChange("def_margen_material")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-3">
                <TextField
                  label="Mano de obra"
                  value={offerHeader.def_margen_m_obra + "%"}
                  onChange={handleChange("def_margen_m_obra")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-3">
                <TextField
                  label="Subcontrata"
                  value={offerHeader.def_margen_subcontrata + "%"}
                  onChange={handleChange("def_margen_subcontrata")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>
            <hr />
            <div ref={divRef} className="row d-flex align-items-center">
              <div className="col-md-3">
                <strong>Recursos internos</strong>
              </div>
              <div className="col-md-3">
                <TextField
                  label="Trabajadores"
                  value={offerHeader.def_trabajadores_asignados}
                  onChange={handleChange("def_trabajadores_asignados")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  type="number"
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-3">
                <TextField
                  label="Coste/hora"
                  value={offerHeader.def_coste_hora_m_obra + " €"}
                  onChange={handleChange("def_coste_hora_m_obra")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-3">
                <TextField
                  label="Comisiones"
                  value={offerHeader.def_comisiones + "%"}
                  onChange={handleChange("def_comisiones")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>
            <hr />
            <div className="row d-flex align-items-center mt-2">
              <div className="col-md-2">
                <strong>Tiempos</strong>
                <TextField
                  label="Jornadas"
                  value={offerHeader.calc_tiempo_jornadas}
                  onChange={handleChange("calc_tiempo_jornadas")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="Horas"
                  value={offerHeader.calc_tiempo_horas}
                  onChange={handleChange("calc_tiempo_horas")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <strong>Mano de obra</strong>
                <TextField
                  label="Coste"
                  value={offerHeader.calc_m_obra_coste + " €"}
                  onChange={handleChange("calc_m_obra_coste")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="PVP"
                  value={offerHeader.calc_m_obra_pvp + " €"}
                  onChange={handleChange("def_trabajadores_asignados")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <strong>Subcontrata</strong>
                <TextField
                  label="Coste"
                  value={offerHeader.calc_subcontrata_coste + " €"}
                  onChange={handleChange("calc_subcontrata_coste")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="PVP"
                  value={offerHeader.calc_subcontrata_pvp + " €"}
                  onChange={handleChange("calc_subcontrata_pvp")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-2">
                <strong>Materiales</strong>
                <TextField
                  label="Coste"
                  value={offerHeader.calc_materiales_coste + " €"}
                  onChange={handleChange("calc_materiales_coste")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="PVP"
                  value={offerHeader.calc_materiales_pvp + " €"}
                  onChange={handleChange("calc_materiales_pvp")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div className="col-md-4">
                <strong>Total</strong>
                <TextField
                  label="Coste"
                  value={offerHeader.calc_total_coste + " €"}
                  onChange={handleChange("calc_total_coste")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  label="PVP"
                  value={offerHeader.calc_total_pvp + " €"}
                  onChange={handleChange("calc_total_pvp")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: true,
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
            </div>
          </CardBody>
          {offerHeader?.id && (
            <>
              <CardHeader title="Detalle" sticky={false}>
                <CardHeaderToolbar>
                  <Button
                    className="ml-3 btn btn-primary"
                    onClick={() => {
                      setOpenPartidaCategoryDialog(true);
                    }}
                    variant="outlined"
                    color="primary"
                  >
                    Nuevo capítulo
                  </Button>
                </CardHeaderToolbar>
              </CardHeader>
              <CardBody>
                {offerHeader?.capitulos?.map((chapter) => {
                  return <OfferChapter chapter={chapter} />;
                })}
              </CardBody>
            </>
          )}
        </Card>
        <Button
          onClick={handleBack}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Atrás
        </Button>
        {/* <Button onClick={() => saveOffer()} variant="outlined" color="primary">
          Guardar
        </Button> */}
        <EditOfferHeaderDialog
          title="Cabecera"
          open={openEditOfferHeaderDialog}
          setOpen={setOpenEditOfferHeaderDialog}
          customers={customers}
          iva={ivas}
          data={offerHeader}
          onSave={(offerHeaderData) => {
            handleGetOfferHeader(
              offerHeaderData?.id,
              offerHeaderData?.revision_num
            );
          }}
        />
        <PartidaCategoryTableDialog
          open={openPartidaCategoryDialog}
          setOpen={setOpenPartidaCategoryDialog}
          data={partidaCategories}
          onSelect={(partidaCategoryId) => {
            setLoading(true);
            postOfferChapter(
              {
                oferta_id: offerHeader?.id,
                revision_num: offerHeader?.revision_num,
                partida_categoria_id: partidaCategoryId,
              },
              loggedUser?.accessToken
            )
              .then((res) => {
                if (res.status === 201) {
                  alertSuccess({
                    title: "¡Guardado!",
                    customMessage: "Capitulo creado con éxito",
                  });
                  setExpandedChapters(
                    expandedChapters?.concat(res.data?.capitulo_id)
                  );
                  handleGetOfferHeader(
                    offerHeader?.id,
                    offerHeader?.revision_num
                  );
                }
              })
              .catch((error) => {
                alertError({
                  error: error,
                  customMessage: "No se ha podido crear el capítulo",
                });
                setLoading(false);
              });
          }}
        />
        <LoadingDialog open={loading} />
      </>
    );
}
